import {
    POI_ASSISTANCE_TYPE_BRAND_A,
    POI_ASSISTANCE_TYPE_BRAND_B,
    POI_ASSISTANCE_TYPE_DETAIL_BODYWORK,
    POI_ASSISTANCE_TYPE_DETAIL_DELIVERYCENTRE,
    POI_ASSISTANCE_TYPE_DETAIL_GLASS,
    POI_ASSISTANCE_TYPE_DETAIL_MECHANICS,
    POI_ASSISTANCE_TYPE_DETAIL_TYRES,
    POI_CHARGING_STATION_TYPE_A,
    POI_CHARGING_STATION_TYPE_B,
    POI_SERVICE_LEASE,
    POI_SERVICE_RENT,
    POI_SERVICE_SHARE,
    POI_SERVICE_SUBSCRIBE,
    POI_STATUS_DISMISSED,
    POI_STATUS_DRAFT,
    POI_STATUS_READY,
    POI_TYPE_ASSISTANCE,
    POI_TYPE_DMS,
    POI_TYPE_DRIVALIAPARKINGLOTS,
    POI_TYPE_EPLUS,
    POI_TYPE_SHARINGPARKINGLOTS,
    POI_TYPE_TEMPLATE_DRIVALIAPARKINGLOTS,
    POI_TYPE_TEMPLATE_SHARINGPARKINGLOTS
} from "./Constants";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";


export const useStatusValuesPoi = () => {
    const {t} = useTranslation(['salesmarketing']);
    const theme = useTheme();
    const getStatusColorPoi = (status: string) => {
        switch (status) {
            case POI_STATUS_READY: return theme.palette.success.transparent;
            case POI_STATUS_DISMISSED: return theme.palette.error.transparent;
            case POI_STATUS_DRAFT: return theme.palette.warning.transparent;
        }
    };

    const getStatusLabelPoi = (status: string) => {
        switch (status) {
            case POI_STATUS_READY: return t('poi.statusValues.ready');
            case POI_STATUS_DISMISSED: return t('poi.statusValues.dismissed');
            case POI_STATUS_DRAFT: return t('poi.statusValues.draft');
            case POI_SERVICE_SHARE: return t('poi.services.share');
            case POI_SERVICE_RENT: return t('poi.services.rent');
            case POI_SERVICE_SUBSCRIBE: return t('poi.services.subscribe');
            case POI_SERVICE_LEASE: return t('poi.services.lease');
            case POI_TYPE_EPLUS: return t('poi.types.eplus');
            case POI_TYPE_DMS: return t('poi.types.dms');
            case POI_TYPE_ASSISTANCE: return t('poi.types.assistance');
            case POI_TYPE_TEMPLATE_SHARINGPARKINGLOTS: return t('poi.types.sharingParkingLots');
            case POI_TYPE_TEMPLATE_DRIVALIAPARKINGLOTS: return t('poi.types.drivaliaParkingLots');
            case POI_CHARGING_STATION_TYPE_A: return t('poi.chargingStationTypes.typeA');
            case POI_CHARGING_STATION_TYPE_B: return t('poi.chargingStationTypes.typeB');
            case POI_ASSISTANCE_TYPE_DETAIL_MECHANICS: return t('poi.assistanceTypeDetails.mechanics');
            case POI_ASSISTANCE_TYPE_DETAIL_BODYWORK: return t('poi.assistanceTypeDetails.bodywork');
            case POI_ASSISTANCE_TYPE_DETAIL_GLASS: return t('poi.assistanceTypeDetails.glass');
            case POI_ASSISTANCE_TYPE_DETAIL_DELIVERYCENTRE: return t('poi.assistanceTypeDetails.deliverycentre');
            case POI_ASSISTANCE_TYPE_DETAIL_TYRES: return t('poi.assistanceTypeDetails.tyres');
            case POI_ASSISTANCE_TYPE_BRAND_A: return t('poi.assistanceBrands.brandA');
            case POI_ASSISTANCE_TYPE_BRAND_B: return t('poi.assistanceBrands.brandB');
            default : return '-'
        }
    };

    return {
        getStatusColorPoi,
        getStatusLabelPoi
    }
}